import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../styles/contactForm.css";

const ContactForm = () => {
    const formik = useFormik({
        initialValues: {
            contactType: "",
            firstName: "",
            lastName: "",
            email: "",
            sector: "",
            companyName: "",
            countryCode: "",
            phoneNumber: "",
            message: "",
            agreeToTerms: false,
        },
        validationSchema: Yup.object({
            contactType: Yup.string().required("Please select a contact type."),
            firstName: Yup.string().required("First name is required."),
            lastName: Yup.string().required("Last name is required."),
            email: Yup.string()
                .email("Invalid email address.")
                .required("Email is required."),
            sector: Yup.string().required("Sector is required."),
            companyName: Yup.string().required("Company name is required."),
            phoneNumber: Yup.string().required("Phone number is required."),
            message: Yup.string().required("Please provide a message."),
            agreeToTerms: Yup.boolean().oneOf(
                [true],
                "You must agree to the terms and conditions."
            ),
        }),
    //     onSubmit: async (values, { resetForm }) => {
    //         try {
    //             // Send email using EmailJS
    //             const response = await emailjs.send(
    //                 "your_service_id", // Replace with your EmailJS Service ID
    //                 "your_template_id", // Replace with your EmailJS Template ID
    //                 {
    //                     contactType: values.contactType,
    //                     firstName: values.firstName,
    //                     lastName: values.lastName,
    //                     email: values.email,
    //                     sector: values.sector,
    //                     companyName: values.companyName,
    //                     countryCode: values.countryCode,
    //                     phoneNumber: values.phoneNumber,
    //                     message: values.message,
    //                 },
    //                 "your_public_key" // Replace with your EmailJS Public Key
    //             );

    //             alert("Email sent successfully!");
    //             resetForm(); // Clear the form fields after submission
    //         } catch (error) {
    //             console.error("Failed to send email:", error);
    //             alert("Failed to send email. Please try again later.");
    //         }
    //     },
    // });
        onSubmit: (values, { resetForm }) => {
            console.log("Form Submitted:", values);

            // Clear all form fields
            resetForm();
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} className="contact-form">
            <h2>I want to get in touch with</h2>
            <select
                name="contactType"
                onChange={formik.handleChange}
                value={formik.values.contactType}
                className={formik.touched.contactType && formik.errors.contactType ? "error" : ""}
            >
                <option value="">Select</option>
                <option value="suggestion">Suggestion</option>
                <option value="support">Support</option>
                <option value="complain">Complain</option>
            </select>
            {formik.touched.contactType && formik.errors.contactType && (
                <div className="error-message">{formik.errors.contactType}</div>
            )}

            <div className="form-row">
                <input
                    type="text"
                    name="firstName"
                    placeholder="First Name*"
                    onChange={formik.handleChange}
                    value={formik.values.firstName}
                    className={formik.touched.firstName && formik.errors.firstName ? "error" : ""}
                />
                <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name*"
                    onChange={formik.handleChange}
                    value={formik.values.lastName}
                    className={formik.touched.lastName && formik.errors.lastName ? "error" : ""}
                />
            </div>
            {formik.touched.firstName && formik.errors.firstName && (
                <div className="error-message">{formik.errors.firstName}</div>
            )}
            {formik.touched.lastName && formik.errors.lastName && (
                <div className="error-message">{formik.errors.lastName}</div>
            )}

            <input
                type="email"
                name="email"
                placeholder="Business Email*"
                onChange={formik.handleChange}
                value={formik.values.email}
                className={formik.touched.email && formik.errors.email ? "error" : ""}
            />
            {formik.touched.email && formik.errors.email && (
                <div className="error-message">{formik.errors.email}</div>
            )}

            <div className="form-row">
                <select
                    name="sector"
                    onChange={formik.handleChange}
                    value={formik.values.sector}
                    className={formik.touched.sector && formik.errors.sector ? "error" : ""}
                >
                    <option value="">Sector*</option>
                    <option value="construction">Construction</option>
                    <option value="engineering">Engineering</option>
                    <option value="interiorDesign">Interior design</option>
                    <option value="electrician">Electrician</option>
                </select>
                <input
                    type="text"
                    name="companyName"
                    placeholder="Company Name*"
                    onChange={formik.handleChange}
                    value={formik.values.companyName}
                    className={formik.touched.companyName && formik.errors.companyName ? "error" : ""}
                />
            </div>
            {formik.touched.sector && formik.errors.sector && (
                <div className="error-message">{formik.errors.sector}</div>
            )}
            {formik.touched.companyName && formik.errors.companyName && (
                <div className="error-message">{formik.errors.companyName}</div>
            )}

            <div className="form-row">
                <input
                    type="text"
                    name="countryCode"
                    placeholder="Country Code"
                    onChange={formik.handleChange}
                    value={formik.values.countryCode}
                />
                <input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number*"
                    onChange={formik.handleChange}
                    value={formik.values.phoneNumber}
                    className={formik.touched.phoneNumber && formik.errors.phoneNumber ? "error" : ""}
                />
            </div>
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                <div className="error-message">{formik.errors.phoneNumber}</div>
            )}

            <textarea
                name="message"
                placeholder="How can we help?"
                onChange={formik.handleChange}
                value={formik.values.message}
                className={formik.touched.message && formik.errors.message ? "error" : ""}
            ></textarea>
            {formik.touched.message && formik.errors.message && (
                <div className="error-message">{formik.errors.message}</div>
            )}
            
            <div className="checkbox-row">
                <input
                    type="checkbox"
                    name="agreeToTerms"
                    onChange={formik.handleChange}
                    checked={formik.values.agreeToTerms}
                />
                <label>
                    I agree to receive communication from build force about products, offers, or services.
                </label>
            </div>
            {formik.touched.agreeToTerms && formik.errors.agreeToTerms && (
                <div className="error-message">{formik.errors.agreeToTerms}</div>
            )}

            <button type="submit">Submit</button>
        </form>
    );
};

export default ContactForm;
